import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { JobCreateResponse } from '../services/JobService/JobService';

export const handlers = [
  http.patch(mockTruktTmsApiUrl('/jobs/:jobGuid'), () => {
    return HttpResponse.json(undefined);
  }),
  http.put(mockTruktTmsApiUrl('/job/:jobGuid/ready'), () => HttpResponse.json()),
  http.delete(mockTruktTmsApiUrl('/job/:jobGuid'), () => HttpResponse.json()),
  http.put(mockTruktTmsApiUrl('/job/:jobGuid/undelete'), () => HttpResponse.json()),
  http.post(mockTruktTmsApiUrl('/job/:jobGuid/hold'), () => HttpResponse.json()),
  http.delete(mockTruktTmsApiUrl('/job/:jobGuid/hold'), () => HttpResponse.json()),
  http.put(mockTruktTmsApiUrl('/job/:jobGuid/cancel'), () => HttpResponse.json()),
  http.put(mockTruktTmsApiUrl('/job/:jobGuid/uncancel'), () => HttpResponse.json()),
  http.put(mockTruktTmsApiUrl('/job/:jobGuid/offers/accept'), () => HttpResponse.json()),
  http.put(mockTruktTmsApiUrl('/job/:jobGuid/offers/cancel'), () => HttpResponse.json()),
  http.put(mockTruktTmsApiUrl('/jobs/:jobGuid/finances'), () => HttpResponse.json()),
  http.post(mockTruktTmsApiUrl('/jobs'), () =>
    HttpResponse.json<JobCreateResponse>({
      guid: 'job-2',
    }),
  ),
  http.get(mockTruktTmsApiUrl('/jobs/statuses'), () =>
    HttpResponse.json([
      'new',
      'tenders',
      'on-hold',
      'ready',
      'posted',
      'requests',
      'pending',
      'declined',
      'dispatched',
      'picked-up',
      'delivered',
      'completed',
      'canceled',
      'deleted',
      'in-progress',
    ]),
  ),
];
